

























































































import {Component, Vue} from "vue-property-decorator";
import breadcrumb from "@/components/common/breadcrumb.vue";
import {getEditItemList, getConfig, querySpuList} from '@/services/api'
import store from "@/store";
import SpuManage from "@/model/Spu";

@Component({
  components: {'zf-breadcrumb': breadcrumb},
})
export default class SpuList extends Vue {
  // 控制列表高度
  public tableHeight = window.innerHeight - 160;
  // 国家列表
  public countryList: {code: string, name: string}[] = [];
  // 投手列表
  public createrList: {code: string, name: string}[] = [];
  // 日期
  public date: string[] = [];
  // 上传表单
  public formData: {
    name?: string,
    spuId?: number,
    status?: number,
    pageNo: number,
    pageSize: number
  } = {
    pageNo: 1,
    pageSize: 20
  }
  // 列表总数
  public totalNum = 0
  // 列表数据
  public tableData: SpuManage[] = []

  /**
   * 初始化方法
   */
  async created(): Promise<void> {
    window.onresize = () => {
      try {
        this.tableHeight = window.innerHeight - 160;
      } catch (e) {}
    }
    await this.getEditItemList();
  }

  /**
   * 获取item列表
   */
  async getEditItemList(): Promise<void> {
    await querySpuList(this.formData, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.tableData = res.data.data.list || [];
        this.totalNum =  res.data.data.total || 0;
      }
    }).catch(() => {})
  }

  /**
   * 编辑
   * @param e 当前item
   */
  edit(e: SpuManage): void {
    window.open('/spu/modify/' + e.spuId,'_blank')
  }

  /**
   * 查询
   */
  search(): void {
    this.formData.pageNo = 1;
    this.getEditItemList();
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.formData.pageSize = val;
    this.formData.pageNo = 1;
    this.getEditItemList();
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.formData.pageNo = val;
    this.getEditItemList();
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }
}

